import { formatDimensionValue } from '@sit/core';
/**
 * Don't use this directly unless you're wrapping it in web and mobile.
 *
 * @deprecated This is not actually deprecated!
 * The intent here is to wrap this function call in web and mobile so that `'Top level'` as the fallback is under the control of Lingui.
 * @private
 */
export function formatIntacctEntityName(entity, fallback) {
    if (!entity) {
        return fallback;
    }
    const { intacctEntityId, name } = entity;
    const isTopLevelEntity = !intacctEntityId;
    return isTopLevelEntity
        ? fallback
        : formatDimensionValue(true, intacctEntityId, name);
}
//# sourceMappingURL=intacct.js.map